
/* styles */
require("!!../../../../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-5c57ffcc&scoped=true!sass-loader?sourceMap!../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./modal-receipt-vp.vue")

var Component = require("!../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./modal-receipt-vp.js"),
  /* template */
  require("!!../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-5c57ffcc!../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./modal-receipt-vp.vue"),
  /* scopeId */
  "data-v-5c57ffcc",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/account/aggregate/modal/modal-receipt-vp.vue
// module id = 1898
// module chunks = 1